import { render, staticRenderFns } from "./SocialList.vue?vue&type=template&id=84a52d50&"
import script from "./SocialList.vue?vue&type=script&lang=js&"
export * from "./SocialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84a52d50')) {
      api.createRecord('84a52d50', component.options)
    } else {
      api.reload('84a52d50', component.options)
    }
    module.hot.accept("./SocialList.vue?vue&type=template&id=84a52d50&", function () {
      api.rerender('84a52d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialList.vue"
export default component.exports